export enum AUIreadyFunctions {
  initHeader = 'initHeader',
  initSearch = 'initSearch',
  initSidebar = 'initSidebar',
  initMobileNav = 'initMobileNav',
  initPortal = 'initPortal',
  initContact = 'initContact',
  initChat = 'initChat',
  initLoadPresentModules = 'initLoadPresentModules',
}

export enum PortletsReadyFunctions {
  initShareButtons = 'initShareButtons',
  initInterestRates = 'initInterestRates',
}

export interface NameFunction<T> {
  name: T;
  functions: Function[];
}

export interface IOptions {
  auiReady?: {
    disabledFunctions?: AUIreadyFunctions[];
    before?: NameFunction<AUIreadyFunctions>[];
    after?: NameFunction<AUIreadyFunctions>[];
    afterAll?: Function[];
  };
  allPortletsReady?: {
    disabledFunctions?: PortletsReadyFunctions[];
    before?: NameFunction<PortletsReadyFunctions>[];
    after?: NameFunction<PortletsReadyFunctions>[];
    afterAll?: Function[];
  };
  documentOnReady?: Function[];
}

export interface IFunction<T> {
  name: T;
  func: Function;
  before?: Function[];
  after?: Function[];
}

export interface IFunctions {
  documentReady: Function[];
  auiReady: IFunction<AUIreadyFunctions>[];
  allPortletsReady: IFunction<PortletsReadyFunctions>[];
}
